import React, { ReactNode } from 'react';
import { TopPerformingBroker } from './data';
import { getUserFullName, removeLINK } from 'utils';
import { AvatarWithInitials } from 'components/AvatarWithInitials';
import { EnterpriseMember } from 'models/Enterprises';

type CellProps = {
  member: EnterpriseMember;
};

const BrokerCell: React.FC<CellProps> = ({ member }) => {
  const { user } = member;

  if (!user) return null;

  const { firstName, lastName } = user;

  return (
    <div className="broker-cell">
      <AvatarWithInitials user={user} />
      <p>{getUserFullName(firstName, lastName)}</p>
    </div>
  );
};

const DealCell: React.FC<CellProps> = ({ member }) => {
  const { totalDeals } = member;

  return <p>{totalDeals}</p>;
};

const ListingsCell: React.FC<CellProps> = ({ member }) => {
  const { totalListings } = member;

  return <p>{totalListings}</p>;
};

const LeadsCell: React.FC<CellProps> = ({ member }) => {
  const { totalLeads } = member;

  return <p>{totalLeads}</p>;
};

const UnitCell: React.FC<CellProps> = ({ member }) => {
  const { businessUnitName } = member;

  return (
    <p className="unit-cell">
      {businessUnitName ? removeLINK(businessUnitName) : '/'}
    </p>
  );
};

export const BODY_CONTENT_GENERATE: Record<
  keyof TopPerformingBroker,
  (cellProps: CellProps) => ReactNode
> = {
  user: (cellProps: CellProps) => <BrokerCell {...cellProps} />,
  totalDeals: (cellProps: CellProps) => <DealCell {...cellProps} />,
  totalListings: (cellProps: CellProps) => <ListingsCell {...cellProps} />,
  totalLeads: (cellProps: CellProps) => <LeadsCell {...cellProps} />,
  businessUnitName: (cellProps: CellProps) => <UnitCell {...cellProps} />,
};
